import { $, aviso, el, esc, limpiar, noContesto, puede, rpc, rpcLee } from './nucleo';

//  VACACIONES, paso 1 (D224, migración 0104). Arriba, «Mis vacaciones»: lo
//  ve cualquiera (`mis_vacaciones`). Abajo, para quien tiene
//  `vacaciones.configurar` (el dueño y el admin global): los días de cada
//  empleado, los grupos de cobertura, los backups y los períodos bloqueados,
//  todo de `vacaciones_panel` y escrito por sus funciones. La pantalla no
//  calcula nada: los días y los miembros de cada grupo los da la base.

const configura = () => puede('vacaciones', 'configurar');
const hoyAnio = () => new Date().getFullYear();

let PANEL: any = null;
let TURNO_MIAS = 0, TURNO_PANEL = 0;   //  una lectura vieja no pinta encima de una nueva
let GRUPO: number | null = null;          //  el grupo del formulario; null: alta
let BLOQUEO: number | null = null;        //  el período del formulario; null: alta
//  Las personas tocadas a mano en el formulario del grupo: id → true
//  (agregada) o false (sacada). Lo que no está acá lo decide el rol.
let A_MANO = new Map<number, boolean>();
//  Si se tocó la lista de personas: si no, no se manda (y lo que la base ya
//  tiene a mano queda como está, aunque el formulario no lo muestre).
let TOCO_PERSONAS = false;

const ddmmaaaa = (iso: string | null | undefined) =>
  iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : '—';
const nombreRol = (c: string) => (PANEL?.roles || []).find((r: any) => r.codigo === c)?.nombre ?? c;
const nombres = (ids: number[]) => (ids || []).map(id => nombreDe(id)).sort((a, b) => a.localeCompare(b)).join(', ');
const nombreDe = (id: number) => (PANEL?.empleados || []).find((e: any) => Number(e.id) === Number(id))?.nombre ?? '¿?';
const chipDias = (d: any) => {
  if (!d) return '<span class="chip c-bad">sin dato</span>';
  const cls = d.provisorio || d.origen === 'a_mano' ? 'c-warn' : d.origen === 'proporcional' ? 'c-info' : 'c-ok';
  const que = d.origen === 'a_mano' ? 'a mano, provisorio' : d.origen === 'alta' ? 'provisorio'
            : d.origen === 'proporcional' ? 'proporcional' : 'por antigüedad';
  return `<span class="chip ${cls}"><b>${esc(d.dias)}</b> días · ${esc(que)}</span>`;
};

export async function cargarVacaciones(){
  leerMias();
  for (const c of ['#cardVacEmpleados', '#cardVacGrupos', '#cardVacBackups', '#cardVacBloqueos'])
    $(c).classList.toggle('oculto', !configura());
  if (configura()) leerPanel();
}

async function leerMias(){
  const turno = ++TURNO_MIAS;
  const { data, error } = await rpcLee('mis_vacaciones', {});
  if (turno !== TURNO_MIAS) return;
  if (error){
    $('#misVac').innerHTML = `<p class="vacio">No se pudieron leer tus días (${esc(error.message)}).</p>`;
    return;
  }
  const m: any = data || {};
  if (!m.empleado){
    $('#misVac').innerHTML = '<p>No figurás como empleado (sos el dueño o tu usuario está inactivo): no tenés días de vacaciones en el sistema.</p>';
    return;
  }
  const d = m.dias || {};
  $('#misVac').innerHTML = `
    <p>En <b>${esc(m.anio)}</b> te corresponden ${chipDias(d)}</p>
    <p class="hint">${esc(d.detalle || '')}</p>
    <p class="hint">${(m.grupos || []).length ? `Tu grupo: <b>${esc(m.grupos.join(', '))}</b>.` : 'No estás en ningún grupo de cobertura.'}
       ${(m.backups || []).length ? ` Te cubre: <b>${esc(m.backups.join(', luego '))}</b>.` : ''}</p>`;
}

async function leerPanel(){
  const turno = ++TURNO_PANEL;
  const sel = $('#vacAnio');
  if (!sel.options.length){
    const a = hoyAnio();
    sel.innerHTML = [a - 1, a, a + 1].map(x => `<option value="${x}"${x === a ? ' selected' : ''}>${x}</option>`).join('');
  }
  const { data, error } = await rpcLee('vacaciones_panel', { p_anio: Number(sel.value) });
  if (turno !== TURNO_PANEL) return;
  if (error){
    PANEL = null;
    const m = `<p class="vacio">No se pudo leer la configuración de vacaciones (${esc(error.message)}). No quiere decir que esté vacía.</p>`;
    for (const t of ['#tblVacEmpleados', '#tblVacGrupos', '#tblVacBackups', '#tblVacBloqueos'])
      $(t).innerHTML = `<tr><td colspan="6">${m}</td></tr>`;
    limpiar('#vacFaltan');
    return;
  }
  PANEL = data;
  pintarEmpleados(); pintarGrupos(); pintarBackups(); pintarBloqueos();
}
$('#vacAnio').onchange = () => leerPanel();

// ---------- los días de cada empleado ----------
function pintarEmpleados(){
  const es = PANEL.empleados || [];
  const faltan = es.filter((e: any) => !e.fecha_ingreso);
  if (faltan.length) aviso('#vacFaltan', 'warn',
    `Falta la fecha de ingreso de ${faltan.length === 1 ? '1 empleado' : faltan.length + ' empleados'} (${faltan.map((e: any) => e.nombre).join(', ')}): sus días son provisorios.`);
  else limpiar('#vacFaltan');
  $('#tblVacEmpleados').innerHTML = es.map((e: any) => `
    <tr data-emp="${e.id}">
      <td><b>${esc(e.nombre)}</b></td>
      <td>${esc((e.roles || []).map(nombreRol).join(', ') || '—')}</td>
      <td><input type="date" data-campo="fecha" value="${esc(e.fecha_ingreso || '')}" aria-label="Fecha de ingreso de ${esc(e.nombre)}"></td>
      <td><input type="number" min="0" max="365" step="1" data-campo="dias" value="${e.dias_provisorios ?? ''}"
                 style="max-width:6rem" aria-label="Días a mano de ${esc(e.nombre)}"${e.fecha_ingreso ? ' title="Con la fecha cargada, los días a mano no se usan"' : ''}></td>
      <td>${chipDias(e.dias)}<div class="hint">${esc(e.dias?.detalle || '')}</div></td>
      <td><button class="b b-sec" type="button" data-guardaremp="${e.id}">Guardar</button></td>
    </tr>`).join('') || '<tr><td colspan="6" class="vacio">No hay empleados activos.</td></tr>';
}
$('#tblVacEmpleados').onclick = async (ev: Event) => {
  const b = el(ev.target).closest('[data-guardaremp]');
  if (!b) return;
  limpiar('#vacEmpMsg');
  const id = Number(b.dataset.guardaremp);
  const e = (PANEL?.empleados || []).find((x: any) => Number(x.id) === id);
  const fila = b.closest('tr') as HTMLElement;
  const f = ($('[data-campo="fecha"]', fila).value || '').trim();
  const dRaw = ($('[data-campo="dias"]', fila).value || '').trim();
  const d: Record<string, unknown> = {};
  if (f !== (e?.fecha_ingreso || '')) d.fecha_ingreso = f;
  if (dRaw !== String(e?.dias_provisorios ?? '')) d.dias_provisorios = dRaw === '' ? null : dRaw;
  if (!Object.keys(d).length){ aviso('#vacEmpMsg', 'ok', 'No cambiaste nada.'); return; }
  b.disabled = true;
  const { data, error } = await rpc('guardar_datos_vacaciones', { p_usuario_id: id, p_datos: d as any });
  b.disabled = false;
  if (noContesto(error)){ aviso('#vacEmpMsg', 'warn', error.message + ' No se sabe si quedó guardado: fijate en la lista antes de repetirlo.'); leerPanel(); return; }
  if (error){ aviso('#vacEmpMsg', 'bad', error.message); return; }
  await leerPanel(); leerMias();
  aviso('#vacEmpMsg', 'ok', (data as any).mensaje);
};

// ---------- los grupos ----------
function pintarGrupos(){
  const gs = PANEL.grupos || [];
  $('#tblVacGrupos').innerHTML = gs.map((g: any) => `
    <tr>
      <td><b>${esc(g.nombre)}</b>${g.activo ? '' : ' <span class="chip c-warn">inactivo</span>'}</td>
      <td class="num">${esc(g.max_ausentes)}</td>
      <td>${esc((g.roles || []).map(nombreRol).join(', ') || '—')}</td>
      <td>${esc(nombres(g.miembros) || 'nadie')}${
        (g.agregados || []).length ? `<div class="hint">Agregados a mano: ${esc(nombres(g.agregados))}</div>` : ''}${
        (g.sacados || []).length ? `<div class="hint">Sacados a mano: ${esc(nombres(g.sacados))}</div>` : ''}</td>
      <td><button class="b b-sec" type="button" data-editgrupo="${g.id}">Cambiar</button></td>
    </tr>`).join('') || '<tr><td colspan="5" class="vacio">Todavía no hay grupos.</td></tr>';
  //  Si el formulario estaba abierto sobre un grupo que ya no está, se cierra.
  if (GRUPO != null && !gs.some((g: any) => Number(g.id) === GRUPO)) cerrarGrupo();
  pintarGruposDeBloqueo();
}
$('#tblVacGrupos').onclick = (ev: Event) => {
  const b = el(ev.target).closest('[data-editgrupo]');
  if (b) abrirGrupo(Number(b.dataset.editgrupo));
};
$('#btnVacGrupoNuevo').onclick = () => abrirGrupo(null);
$('#vgCancelar').onclick = () => cerrarGrupo();

function cerrarGrupo(){ GRUPO = null; $('#formVacGrupo').classList.add('oculto'); }

function rolesElegidos(): string[] {
  return Array.from(document.querySelectorAll<HTMLInputElement>('#vgRoles input:checked')).map(i => i.value);
}
function entraPorRol(e: any, roles: string[]){ return (e.roles || []).some((r: string) => roles.includes(r)); }

function pintarPersonasDelGrupo(){
  const roles = rolesElegidos();
  $('#vgPersonas').innerHTML = (PANEL.empleados || []).map((e: any) => {
    const porRol = entraPorRol(e, roles);
    const mano = A_MANO.get(Number(e.id));
    const dentro = mano ?? porRol;
    const nota = mano === true ? ' <span class="hint">(a mano)</span>' : mano === false ? ' <span class="hint">(sacado a mano)</span>' : '';
    return `<label><input type="checkbox" value="${e.id}"${dentro ? ' checked' : ''}> ${esc(e.nombre)}${nota}</label>`;
  }).join('') || '<span class="hint">No hay empleados activos.</span>';
}

function abrirGrupo(id: number | null){
  if (!PANEL) return;
  GRUPO = id;
  limpiar('#vgMsg');
  const g = id == null ? null : (PANEL.grupos || []).find((x: any) => Number(x.id) === id);
  $('#vgTit').textContent = g ? `Grupo «${g.nombre}»` : 'Nuevo grupo';
  $('#vgNombre').value = g?.nombre || '';
  $('#vgMax').value = g ? String(g.max_ausentes) : '1';
  $('#vgActivo').checked = g ? !!g.activo : true;
  $('#vgActivoLbl').classList.toggle('oculto', !g);
  $('#vgBorrar').classList.toggle('oculto', !g);
  $('#vgGuardar').textContent = g ? 'Guardar' : 'Crear el grupo';
  $('#vgRoles').innerHTML = (PANEL.roles || []).map((r: any) =>
    `<label><input type="checkbox" value="${esc(r.codigo)}"${(g?.roles || []).includes(r.codigo) ? ' checked' : ''}> ${esc(r.nombre)}</label>`).join('');
  A_MANO = new Map();
  TOCO_PERSONAS = false;
  for (const u of g?.agregados || []) A_MANO.set(Number(u), true);
  for (const u of g?.sacados || []) A_MANO.set(Number(u), false);
  pintarPersonasDelGrupo();
  $('#formVacGrupo').classList.remove('oculto');
  $('#formVacGrupo').scrollIntoView({ block: 'nearest' });
  $('#vgNombre').focus();
}
$('#vgRoles').onchange = () => pintarPersonasDelGrupo();
$('#vgPersonas').onchange = (ev: Event) => {
  const i = ev.target as HTMLInputElement;
  const e = (PANEL?.empleados || []).find((x: any) => Number(x.id) === Number(i.value));
  if (!e) return;
  TOCO_PERSONAS = true;
  //  Si queda como lo decide el rol, deja de estar «a mano».
  if (i.checked === entraPorRol(e, rolesElegidos())) A_MANO.delete(Number(e.id));
  else A_MANO.set(Number(e.id), i.checked);
  pintarPersonasDelGrupo();
};

$('#formVacGrupo').onsubmit = async (ev: Event) => {
  ev.preventDefault();
  limpiar('#vgMsg');
  const g = GRUPO == null ? null : (PANEL?.grupos || []).find((x: any) => Number(x.id) === GRUPO);
  const roles = rolesElegidos();
  const d: Record<string, unknown> = {
    nombre: ($('#vgNombre').value || '').trim(),
    max_ausentes: ($('#vgMax').value || '').trim(),
  };
  //  Los roles: los que el formulario no ofrece (un rol desactivado) se
  //  conservan; y si no cambiaron, no se mandan.
  const ofrecidos = (PANEL?.roles || []).map((r: any) => r.codigo);
  const rolesFinal = [...roles, ...((g?.roles || []).filter((c: string) => !ofrecidos.includes(c)))];
  const mismos = (a: string[], b: string[]) => a.length === b.length && a.every(x => b.includes(x));
  if (!g || !mismos(rolesFinal, g.roles || [])) d.roles = rolesFinal;
  //  Las personas, sólo si se tocaron. Lo que se manda a mano son sólo las
  //  excepciones al rol, más las que la base tiene de gente que el
  //  formulario no muestra (inactiva).
  if (!g || TOCO_PERSONAS){
    const agregados: number[] = [], sacados: number[] = [];
    const listados = new Set((PANEL?.empleados || []).map((e: any) => Number(e.id)));
    for (const e of PANEL?.empleados || []){
      const m = A_MANO.get(Number(e.id));
      if (m === true && !entraPorRol(e, roles)) agregados.push(Number(e.id));
      if (m === false && entraPorRol(e, roles)) sacados.push(Number(e.id));
    }
    for (const u of g?.agregados || []) if (!listados.has(Number(u))) agregados.push(Number(u));
    for (const u of g?.sacados || []) if (!listados.has(Number(u))) sacados.push(Number(u));
    d.agregados = agregados; d.sacados = sacados;
  }
  if (g) d.activo = $('#vgActivo').checked;
  const b = $('#vgGuardar'); b.disabled = true;
  const { data, error } = await rpc('guardar_grupo_cobertura', { p_grupo_id: GRUPO as any, p_datos: d as any });
  b.disabled = false;
  if (noContesto(error)){ aviso('#vgMsg', 'warn', error.message + ' No se sabe si quedó guardado: fijate en la lista antes de repetirlo.'); leerPanel(); return; }
  if (error){ aviso('#vgMsg', 'bad', error.message); return; }
  cerrarGrupo();
  await leerPanel(); leerMias();
  aviso('#vacGruposMsg', 'ok', (data as any).mensaje);
};

$('#vgBorrar').onclick = async () => {
  if (GRUPO == null) return;
  const g = (PANEL?.grupos || []).find((x: any) => Number(x.id) === GRUPO);
  if (!confirm(`¿Borrar el grupo «${g?.nombre ?? ''}»?`)) return;
  const { data, error } = await rpc('borrar_grupo_cobertura', { p_grupo_id: GRUPO });
  if (noContesto(error)){ aviso('#vgMsg', 'warn', error.message + ' No se sabe si se borró: fijate en la lista.'); leerPanel(); return; }
  if (error){ aviso('#vgMsg', 'bad', error.message); return; }
  cerrarGrupo();
  await leerPanel(); leerMias();
  aviso('#vacGruposMsg', 'ok', (data as any).mensaje);
};

// ---------- los backups ----------
function pintarBackups(){
  const es = PANEL.empleados || [];
  const opciones = (yo: number, elegido: number | undefined) => `<option value="">—</option>` +
    es.filter((x: any) => Number(x.id) !== yo).map((x: any) =>
      `<option value="${x.id}"${Number(x.id) === Number(elegido) ? ' selected' : ''}>${esc(x.nombre)}</option>`).join('');
  $('#tblVacBackups').innerHTML = es.map((e: any) => `
    <tr data-emp="${e.id}">
      <td><b>${esc(e.nombre)}</b></td>
      ${[0, 1, 2].map(i => `<td><select data-orden="${i}" aria-label="Backup ${i + 1} de ${esc(e.nombre)}">${opciones(Number(e.id), (e.backups || [])[i])}</select></td>`).join('')}
      <td><button class="b b-sec" type="button" data-guardarbk="${e.id}">Guardar</button></td>
    </tr>`).join('') || '<tr><td colspan="5" class="vacio">No hay empleados activos.</td></tr>';
}
$('#tblVacBackups').onclick = async (ev: Event) => {
  const b = el(ev.target).closest('[data-guardarbk]');
  if (!b) return;
  limpiar('#vacBackupsMsg');
  const fila = b.closest('tr') as HTMLElement;
  const lista = [0, 1, 2].map(i => ($(`[data-orden="${i}"]`, fila).value || '')).filter(v => v !== '').map(Number);
  b.disabled = true;
  const { data, error } = await rpc('guardar_backups', { p_usuario_id: Number(b.dataset.guardarbk), p_backups: lista });
  b.disabled = false;
  if (noContesto(error)){ aviso('#vacBackupsMsg', 'warn', error.message + ' No se sabe si quedó guardado: fijate en la lista antes de repetirlo.'); leerPanel(); return; }
  if (error){ aviso('#vacBackupsMsg', 'bad', error.message); return; }
  await leerPanel(); leerMias();
  aviso('#vacBackupsMsg', 'ok', (data as any).mensaje);
};

// ---------- los períodos bloqueados ----------
function pintarGruposDeBloqueo(elegidos?: number[]){
  const ya = elegidos ?? Array.from(document.querySelectorAll<HTMLInputElement>('#vbGrupos input:checked')).map(i => Number(i.value));
  $('#vbGrupos').innerHTML = (PANEL?.grupos || []).map((g: any) =>
    `<label><input type="checkbox" value="${g.id}"${ya.includes(Number(g.id)) ? ' checked' : ''}> ${esc(g.nombre)}</label>`).join('')
    || '<span class="hint">No hay grupos: el período vale para todos.</span>';
}
function pintarBloqueos(){
  const bs = PANEL.bloqueos || [];
  const nombreGrupo = (id: number) => (PANEL.grupos || []).find((g: any) => Number(g.id) === Number(id))?.nombre ?? '¿?';
  $('#tblVacBloqueos').innerHTML = bs.map((b: any) => `
    <tr>
      <td>${esc(ddmmaaaa(b.desde))}</td><td>${esc(ddmmaaaa(b.hasta))}</td>
      <td>${(b.grupos || []).length ? esc(b.grupos.map(nombreGrupo).join(', ')) : '<b>todos</b>'}</td>
      <td>${esc(b.motivo || '—')}</td>
      <td><div class="fila-acc">
        <button class="b b-sec" type="button" data-editbl="${b.id}">Cambiar</button>
        <button class="b b-sec" type="button" data-borrarbl="${b.id}">Borrar</button></div></td>
    </tr>`).join('') || '<tr><td colspan="5" class="vacio">No hay períodos bloqueados.</td></tr>';
  if (BLOQUEO != null && !bs.some((b: any) => Number(b.id) === BLOQUEO)) limpiarBloqueo();
}
function limpiarBloqueo(){
  BLOQUEO = null;
  $('#vbTit').textContent = 'Nuevo período';
  $('#vbGuardar').textContent = 'Agregar el período';
  $('#vbCancelar').classList.add('oculto');
  $('#vbDesde').value = ''; $('#vbHasta').value = ''; $('#vbMotivo').value = '';
  ($('#vbHasta') as unknown as HTMLInputElement).min = '';
  pintarGruposDeBloqueo([]);
}
$('#vbCancelar').onclick = () => { limpiar('#vbMsg'); limpiarBloqueo(); };
//  Al elegir el «desde», el calendario del «hasta» no ofrece días anteriores.
$('#vbDesde').onchange = () => { ($('#vbHasta') as unknown as HTMLInputElement).min = $('#vbDesde').value || ''; };
$('#tblVacBloqueos').onclick = async (ev: Event) => {
  const ed = el(ev.target).closest('[data-editbl]');
  const bo = el(ev.target).closest('[data-borrarbl]');
  if (ed){
    const b = (PANEL?.bloqueos || []).find((x: any) => Number(x.id) === Number(ed.dataset.editbl));
    if (!b) return;
    BLOQUEO = Number(b.id);
    limpiar('#vbMsg');
    $('#vbTit').textContent = `Cambiar el período del ${ddmmaaaa(b.desde)} al ${ddmmaaaa(b.hasta)}`;
    $('#vbGuardar').textContent = 'Guardar';
    $('#vbCancelar').classList.remove('oculto');
    $('#vbDesde').value = b.desde; $('#vbHasta').value = b.hasta; $('#vbMotivo').value = b.motivo || '';
    ($('#vbHasta') as unknown as HTMLInputElement).min = b.desde;
    pintarGruposDeBloqueo((b.grupos || []).map(Number));
    $('#formVacBloqueo').scrollIntoView({ block: 'nearest' });
    return;
  }
  if (bo){
    const b = (PANEL?.bloqueos || []).find((x: any) => Number(x.id) === Number(bo.dataset.borrarbl));
    if (!b || !confirm(`¿Borrar el período del ${ddmmaaaa(b.desde)} al ${ddmmaaaa(b.hasta)}?`)) return;
    limpiar('#vbMsg');
    const { data, error } = await rpc('borrar_bloqueo_vacaciones', { p_bloqueo_id: Number(b.id) });
    if (noContesto(error)){ aviso('#vbMsg', 'warn', error.message + ' No se sabe si se borró: fijate en la lista.'); leerPanel(); return; }
    if (error){ aviso('#vbMsg', 'bad', error.message); return; }
    await leerPanel();
    aviso('#vbMsg', 'ok', (data as any).mensaje);
  }
};
$('#formVacBloqueo').onsubmit = async (ev: Event) => {
  ev.preventDefault();
  limpiar('#vbMsg');
  const d = {
    desde: $('#vbDesde').value || '', hasta: $('#vbHasta').value || '',
    motivo: ($('#vbMotivo').value || '').trim(),
    grupos: Array.from(document.querySelectorAll<HTMLInputElement>('#vbGrupos input:checked')).map(i => Number(i.value)),
  };
  const b = $('#vbGuardar'); b.disabled = true;
  const { data, error } = await rpc('guardar_bloqueo_vacaciones', { p_bloqueo_id: BLOQUEO as any, p_datos: d as any });
  b.disabled = false;
  if (noContesto(error)){ aviso('#vbMsg', 'warn', error.message + ' No se sabe si quedó guardado: fijate en la lista antes de repetirlo.'); leerPanel(); return; }
  if (error){ aviso('#vbMsg', 'bad', error.message); return; }
  limpiarBloqueo();
  await leerPanel();
  aviso('#vbMsg', 'ok', (data as any).mensaje);
};
